export const VehicleCardSkeleton = () => (
  <div
    data-testid="vehicle-card-skeleton"
    className="flex flex-col bg-ink-900 border border-white/[0.06] animate-pulse"
  >
    <div className="aspect-[3/2] bg-ink-850" />
    <div className="flex flex-col gap-4 p-6 md:p-7">
      <div className="h-3 w-20 bg-ink-850" />
      <div className="h-7 w-3/4 bg-ink-850" />
      <div className="grid grid-cols-2 gap-3 pt-4 hairline-t">
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="h-8 bg-ink-850" />
        ))}
      </div>
      <div className="h-10 w-40 bg-ink-850 mt-2" />
      <div className="h-12 bg-ink-850" />
    </div>
  </div>
);

export default VehicleCardSkeleton;
